<script lang="ts">
  let {
    image,
    width,
    height,
    className = 'fill-[currentcolor]',
  }: {
    image:
      | 'calendar'
      | 'check'
      | 'chevron-down'
      | 'chevron-left'
      | 'chevron-right'
      | 'cross-normal'
      | 'cross'
      | 'exit'
      | 'facebook'
      | 'filters'
      | 'hamburger-normal'
      | 'hamburger-regular'
      | 'instagram'
      | 'link'
      | 'linkedin'
      | 'location'
      | 'logo-rabo-dbr'
      | 'logo-r2r-full'
      | 'logo-r2r-plain-wrap'
      | 'logo-r2r-plain'
      | 'logo-yellow-b'
      | 'pencil'
      | 'plus-squared'
      | 'profile-normal'
      | 'profile-regular'
      | 'trash'
      | 'whatsapp'
      | 'x';
    width: number;
    height: number;
    className?: string;
  } = $props();
</script>

<svg class={className} {width} {height} aria-hidden="true">
  <use xlink:href={`/svg-sprite/sprite.svg#${image}`}></use>
</svg>
